import React, { useEffect, useState } from "react";
import Input from "components/input/input";
import Select from "components/select/select";

import { useCountries } from "redux/modules/country/hooks";
import { useStates } from "redux/modules/states/hooks";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import PopInfo from "components/info-popup/pop-info";
import MultiRangeSlider from "components/multiRange/MultiRangeSlider";
import { useLanguages } from "redux/modules/languages/hook";
import { useTranslation } from "react-i18next";
import AutoCompleteAddress from "components/google-address/auto-complete";

const genderPosition = {
  left:"50px",
  right:"50px"
}

export default function AdvanceSearch({
  state,
  handleInputChange = () => {},
  handleUpdateGender = () => {},
  handleAddressChange = () => {},
  open = false,
  occupations=[]
}) {
    
  const {t} = useTranslation()
  const profileTypes = [
    { label: "All", value: "all" },
    { label: t("personal"), value: "personal" },
    { label: t("business"), value: "business" },
    { label: t("group"), value: "group" },
    { label: t("team"), value: "team" },
    { label: t("character"), value: "character" },
  ]; 

  const { http } = global.services;
  const {
    initialize: initializeCountries,
    refresh: refreshCountries,
    countries = [],
    setCountries,
  } = useCountries();

  const {
    initialize: initializeStates,
    refresh: refreshStates,
    states = [],
    setStates
  } = useStates();
  const { languages } = useLanguages();

  const parseLanguage = (languages) => {
    return languages?.map(item => ({
      lang_id: item.id,
      level: item.level,
      level_id: item.level_id,
      country: item.country,
      countryCode: item.countryCode,
      shortName: item.shortName,
      label: item.name,
      value:item.id,
      orderNumber: item.orderNumber
    })) || [];
  };

  const [overflow, setOverflow] = useState(null);
  const [statesOptions, setStatesOptions] = useState(states);
  const [countryOptions, setCountryOptions] = useState(countries); 
  const [age, setAge] = useState({max:100,min:18}); 

  /**
   * This method will get countries
   */
  const getCountries = async () => {
    try {
      const { data } = await http.get("public/countries");
      const payload = data.map((d) => ({ label: d.name, value: d.name }));
      setCountries(payload);
      setCountryOptions(payload);
    } catch (err) {
      console.log("error@getCountries", err);
    }
  };

  /**
   * This method will get states
   */
  const getStates = async () => {
    try {
      const { data } = await http.get("public/states");
      const payload = data.map((d) => ({ label: d.name, value: d.name }));
      setStates(payload);
      setStatesOptions(payload);
    } catch (err) {
      console.log("error@getStates", err);
    }
  }; 

  useEffect(() => {
    if (state) {
      let countryOpt = countryOptions.map((co) => {
        if (co.value === state.country) {
          return {
            ...co,
            selected: true,
          };
        } else {
          const { selected, ...val } = co;
          return val;
        }
      });
      setCountryOptions((prev) => countryOpt);

      let stateOpt = statesOptions.map((so) => {
        if (so.value === state.state) {
          return {
            ...so,
            selected: true,
          };
        } else {
          const { selected, ...val } = so;
          return val;
        }
      });
      setStatesOptions((prev) => stateOpt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    if (!open) {
      setOverflow(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  /**
   * This effect will run during the initialization
   * and run every time refresh countries state change
   */
  useEffect(() => {
    if (initializeCountries) getCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCountries]);

  /**
   * This effect will run during the initialization
   * and run every time refresh states state change
   */
  useEffect(() => {
    if (initializeStates) getStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshStates]);

  // useEffect(()=>{
  //       // handleInputChange({
  //       //         target: { name: "age", value: {...age} },
  //       //       })
  //       alert(1);
  // },[age])

  return (
    <div
      className={`w-full mt-3 advance-search ${
        open ? `open ${overflow}` : ""
      }`}>
      <div className="w-full grid 2md:grid-cols-2 gap-x-7 gap-y-3.5 ">
        {/* <Input
          inputContainerClass="flex-1"
          value={state?.name}
          name="name"
          outsideLabel={t("name")}
          placeholder="Bobby Diggs"
          outsideLabelClass="text-sm font-bold text-darkerGray"
          noLabelPaddingY="1rem"
          type="text"
          onChange={handleInputChange}
        /> */}
        <Select
          label={t("profileTypes")}
          options={profileTypes}
          placeholder={t('selectType')}
          name="type"
          value={
            state.profileTypes &&
            profileTypes.filter((pt) => pt.value === state.profileTypes)
          }
          onChange={(e) =>
            handleInputChange({
              target: { name: "profileTypes", value: e.value },
            })
          }
        />
        <Select
          label={"Job / Role"}
          options={occupations}
          placeholder={t('selectType')}
          name="type"
          className="capitalize"
          value={
            state.job_role &&
            occupations.filter((pt) => pt.value === state.job_role)
          }
          onChange={(e) =>
            handleInputChange({
              target: { name: "job_role", value: e.value },
            })
          }
        />
      </div>
      <div className="w-full">
        <div className="w-full">
          <label for="address" className="text-sm font-bold text-darkerGray leading-4">{t('location_egCityStateCountry')}</label>
          <AutoCompleteAddress
            key={1}
            name="location"
            value={state?.location}
            onChange={handleAddressChange}
            placeholder="Melbourne VIC, Australia"
            errorMessage={state.validationErrors?.location}
            // Do not restrict to cities only so users can pick state or country-only
            placeTypes={[]}
          />
        </div>
      
      </div>
      <div className="w-full grid 2md:grid-cols-2 gap-x-7 gap-y-3.5 mt-5">
        <Select
            formContainer="flex-1"
            label={t('languagesSpoken')}
            options={parseLanguage(languages).filter((co) => !co.selected)}
            placeholder={t('pleaseSelect')}
            onFocus={() => setOverflow("overflow-visible")}
            name="lang_id"
            height={58}
            onChange={(e) =>
              handleInputChange({
                target: { name: "lang_id", value: e ? e.value : "" },
              })
            }
            isClearable={true}
          />
        <div className="relative w-full h-[90px]">
          <label className="text-sm font-bold text-darkerGray">{t('ageRange')}</label>
          <MultiRangeSlider
            label="Ages"
            name="age"
            min={18}
            max={100}
            initVal={age}
            minLimit={18}
            onChange = {({ min, max })=>{  
              if(min !== 0 && max !== 100){
                setAge(prev => {return {...prev, max,min}})
              }
              handleInputChange({
                target: { name: "age", value: {min, max} },
              })

            }}
            closeButton={true}
          />
          <div className=" text-sm absolute -bottom-4 left-0 w-full"> 
            {
              age.min < 18 &&
              <div className="text-red text-center">
                The platform is for 18 years old and above
              </div>
            }
          </div>
        </div>
      </div>
      {
        (state?.profileTypes === 'personal' || state?.profileTypes === 'character') &&
          <div className="w-full mt-3.5">
            <div className="w-full flex flex-row gap-x-2 items-center justify-between mt-12 2md:mt-0">
              <p className="text-sm text-darkerGray font-bold">{t('gender')}</p>
              <PopInfo
                  type="gender_others"
                  direction="right"
                  responsive={genderPosition}
                  onClickCallBack={() => setOverflow("overflow-visible")}
                />
            </div>
            <div className="w-full flex items-center justify-between flex-1">
              <div className="w-full mt-1 md:mt-3.5 md:flex md:space-x-10 md:space-y-0">
                <CustomCheckbox
                  label={
                    <p className="text-sm text-darkerGray leading-6 ml-3 mt-0.5">
                      {t('male')}
                    </p>
                  }
                  name="genderMale"
                  checked={state.gender === "Male"}
                  onChange={(e) => handleUpdateGender(e, "Male")}
                />
                <CustomCheckbox
                  label={
                    <p className="text-sm text-darkerGray leading-6 ml-3 mt-0.5">
                      {t('female')}
                    </p>
                  }
                  name="genderFemale"
                  checked={state.gender === "Female"}
                  onChange={(e) => handleUpdateGender(e, "Female")}
                />
                <div className="flex">  
                  <CustomCheckbox
                    label={
                      <p className="text-sm text-darkerGray leading-6 ml-3 mt-0.5">
                        {t('other')}
                      </p>
                    }
                    name="genderOthers"
                    checked={state.gender === "others"}
                    onChange={(e) => handleUpdateGender(e, "others")}
                  />
                  {/* <div className="others-input">
                    <input />
                  </div> */}
                </div>
              </div>
              {/*  */}
              
            </div>
          </div>
      }
      
    </div>
  );
}
